import { useState, useEffect, useRef, useCallback } from "react";
import { api } from "@/lib/api";

export function usePolling(fn, intervalMs, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const saved = useRef(fn);
  saved.current = fn;

  const run = useCallback(async () => {
    try {
      const res = await saved.current();
      setData(res);
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    run();
    if (!intervalMs) return;
    const id = setInterval(run, intervalMs);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, loading, error, refresh: run };
}

export function useQuote(intervalMs = 4000) {
  return usePolling(async () => (await api.get("/market/quote")).data, intervalMs, []);
}
